import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function TokenFilledIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1m1.169 5.563a1.5 1.5 0 0 0-2.338 0c-.13.162-.266.48-.537 1.118-.146.343-.22.515-.305.674A4 4 0 0 1 8.355 9.99c-.159.086-.33.159-.674.305-.637.27-.956.407-1.118.537a1.5 1.5 0 0 0 0 2.338c.162.13.48.265 1.118.536.344.146.515.22.674.306a4 4 0 0 1 1.634 1.633c.086.159.159.331.305.675.27.637.407.956.537 1.119a1.5 1.5 0 0 0 2.338 0c.13-.162.266-.482.537-1.119.146-.344.22-.516.305-.675.372-.694.94-1.261 1.634-1.633.159-.086.33-.16.674-.306.637-.27.956-.406 1.119-.536a1.5 1.5 0 0 0 0-2.338c-.163-.13-.482-.266-1.119-.537a9 9 0 0 1-.674-.305 4 4 0 0 1-1.634-1.634c-.086-.159-.159-.33-.305-.674-.27-.637-.407-.956-.537-1.118"
        clipRule="evenodd"
      />
    </Icon>
  );
}

TokenFilledIcon.displayName = 'TokenFilledIcon';
